import { SWRConfiguration, SWRResponse } from 'swr';
import { InstitutionPersonnelResponse, GetInstitutionPersonnel} from '../../api/dtos';
import { useMemo } from 'react';
import { useGet } from '@ngt/opms';

const getData = (response?: SWRResponse<InstitutionPersonnelResponse, InstitutionPersonnelResponse>) =>  response?.data?.personnel;

const getError = (response?: SWRResponse<InstitutionPersonnelResponse, InstitutionPersonnelResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const usePersonnel = (roles?: number[], institutionCode?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return institutionCode ?
            () => {
                return new GetInstitutionPersonnel({ institutionCode, roles });
            } :
            undefined;
    }, [institutionCode, ...(roles ?? [])])

    return useGet(request, { getData, getError }, configuration);
};

export default usePersonnel;